/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CircularContent } from '../../models/circular-content';

export interface ApiMasterCircularContentGetByIdGet$Params {
  id?: string;
}

export function apiMasterCircularContentGetByIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterCircularContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CircularContent>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCircularContentGetByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CircularContent>;
    })
  );
}

apiMasterCircularContentGetByIdGet.PATH = '/api/Master/CircularContent/GetById';
